import { RESTError } from "../core/RESTError";

/**
 * An error that occurs if a product download is not possible due an invalid expire date.
 */
export class ProductInvalidExpiryDateError extends RESTError {}
